/**
 * Algebra I · Poziom 4 — treść zadań, polski.
 *
 * Treść paczki kursu leży obok wysyłanych paczek zadań, w content/lang, i nigdy
 * w src/. Ta sama zasada i ten sam powód: src/ nie niesie języka. Paczka z
 * src/content/packs importuje ten plik, a rejestr dokłada go za
 * content/lang/items.*.js.
 *
 * STYL DOMU. Uproszczona polszczyzna techniczna: jedno słowo znaczy jedno,
 * jedno polecenie na zdanie, strona czynna, poniżej dwudziestu słów. Sytuacja
 * to JEDNO zdanie i nigdy nie podaje liczby, której matematyka nie używa.
 *
 * JEDNO SŁOWO, JEDNO ZNACZENIE — słownik, który dokłada ten poziom:
 *   kreska      linia nad pierwiastkiem kwadratowym
 *   pierwiastek liczba, która pomnożona przez siebie daje liczbę spod kreski
 *   kwadrat     liczba pomnożona przez samą siebie
 *   nawias      jedna z dwóch części iloczynu, uczona na Poziomie 3
 *   zero        wejście, przy którym reguła ma wartość zero
 *   wierzchołek wejście, przy którym reguła kwadratowa przestaje opadać
 *   krzywa      kształt, który rysuje reguła kwadratowa
 * „wierzchołek" zawsze oznacza parę odczytów w punkcie zwrotu. „Wartość" to
 * wyjście; wejścia nigdy nie nazywamy wartością.
 */
export default {

  // ---------------------------------------------------------------- pytania
  'l4.ask.pullOutTheSquare': 'Wyciągnij spod kreski największy kwadrat.',
  'l4.ask.joinTheRoots': 'Połącz to w jeden pierwiastek.',
  'l4.ask.clearTheBottom': 'Usuń pierwiastek z dołu.',
  'l4.ask.openAndTidy': 'Otwórz nawias. Potem połącz to, co się da.',
  'l4.ask.writeAsProduct': 'Zapisz to jako iloczyn nawiasów.',
  'l4.ask.areaAsProduct': 'Zapisz pole jako jego dwa boki.',
  'l4.ask.whichComesApart': 'Tylko jedno z nich się rozkłada. Zapisz je jako iloczyn.',
  'l4.ask.whichIsSquareMinusSquare': 'Jedno z nich to kwadrat minus kwadrat. Zapisz je jako iloczyn.',
  'l4.ask.writeTheQuotient': 'Zapisz wynik tego dzielenia.',
  'l4.ask.writeTheRemainder': 'Co zostaje?',
  'l4.ask.otherSide': 'Zapisz drugi bok.',
  'l4.ask.whereIsItZero': 'Gdzie to ma zero?',
  'l4.ask.whichInputsShutIt': 'Które wejścia to zamykają?',
  'l4.ask.solveIt': 'Znajdź każdą wartość, która pasuje.',
  'l4.ask.howWideIsIt': 'Jak szerokie to jest?',
  'l4.ask.howLongIsTheSide': 'Jak długi jest bok?',
  'l4.ask.showTheTurn': 'Zapisz tę regułę tak, aby wierzchołek był widoczny.',
  'l4.ask.whereDoesItTurn': 'Gdzie ta reguła się odwraca?',
  'l4.ask.lineOfSymmetry': 'Zapisz prostą, wzdłuż której krzywa się składa.',
  'l4.ask.greatestValue': 'Jaka jest największa wartość tej reguły?',
  'l4.ask.leastValue': 'Jaka jest najmniejsza wartość tej reguły?',
  'l4.ask.whereItCrossesUpright': 'Jakie jest wyjście na starcie?',
  'l4.ask.whereItCrossesFlat': 'Gdzie ta reguła ma zero?',
  'l4.ask.whichOutputs': 'Jakie wyjścia daje ta reguła?',
  'l4.ask.readingAt': 'Odczyty idą za regułą kwadratową. Jaki jest odczyt w {at}?',
  'l4.ask.ruleTurnsAt': 'Wierzchołek jest w $\\left({h}, {k}\\right)$. Zapisz regułę tak, aby był widoczny.',
  'l4.ask.ruleIsZeroAt': 'Ta reguła ma zero w {p} i w {q}. Zapisz ją jako iloczyn.',
  'l4.ask.writeWithoutBrackets': 'Zapisz tę regułę bez nawiasów.',
  'l4.ask.whenDoesItLand': 'Kiedy dosięga ziemi?',
  'l4.ask.greatestHeight': 'Jaka jest największa wysokość?',
  'l4.ask.largestArea': 'Jakie jest największe pole?',
  'l4.ask.bestPriceAndTakings': 'Podaj najlepszą cenę i utarg przy niej.',

  // ---------------------------------------------------------------- sytuacje
  'l4.ctx.squarePlate': 'Pierwiastek podaje bok tej kwadratowej płyty kadłuba.',
  'l4.ctx.squareBay': 'Pierwiastek podaje bok tej kwadratowej zatoki lądowania.',
  'l4.ctx.squarePad': 'Pierwiastek podaje bok tej kwadratowej płyty startowej.',
  'l4.ctx.squareVat': 'Pierwiastek podaje bok tej kwadratowej kadzi mieszalnej.',
  'l4.ctx.sideDeck': 'Kwadratowy pokład ma to pole. Litera to jeden bok.',
  'l4.ctx.sideTile': 'Kwadratowa płytka ma to pole. Litera to jeden bok.',
  'l4.ctx.sideFrame': 'Kwadratowa rama ma to pole. Litera to jeden bok.',
  'l4.ctx.sideHatch': 'Kwadratowy właz ma to pole. Litera to jeden bok.',
  'l4.ctx.braceStrut': 'Ten zastrzał przecina dwie rozpory zbiegające się pod kątem prostym.',
  'l4.ctx.braceMast': 'Ten odciąg przecina maszt i pokład pod kątem prostym.',
  'l4.ctx.braceRamp': 'Ta belka przecina rampę i podłogę pod kątem prostym.',
  'l4.ctx.braceHatch': 'Ten pręt przecina dwie krawędzie włazu pod kątem prostym.',
  'l4.ctx.mixRail': 'Dwie szyny leżą jedna za drugą, a pierwiastek podaje każdą długość.',
  'l4.ctx.mixCable': 'Dwie liny leżą jedna za drugą, a pierwiastek podaje każdą długość.',
  'l4.ctx.mixSeam': 'Dwie spoiny leżą jedna za drugą, a pierwiastek podaje każdą długość.',
  'l4.ctx.mixPipe': 'Dwie rury leżą jedna za drugą, a pierwiastek podaje każdą długość.',
  'l4.ctx.plotBay': 'Ta zatoka to prostokąt. Boków jeszcze nie znamy.',
  'l4.ctx.plotDeck': 'Ten pokład to prostokąt. Boków jeszcze nie znamy.',
  'l4.ctx.plotField': 'Ta działka to prostokąt. Boków jeszcze nie znamy.',
  'l4.ctx.plotStore': 'Ten magazyn to prostokąt. Boków jeszcze nie znamy.',
  'l4.ctx.shareFloor': 'Ta podłoga to prostokąt. Pole jest na górze, bok na dole.',
  'l4.ctx.shareRoll': 'Ten zwój to prostokąt. Pole jest na górze, bok na dole.',
  'l4.ctx.shareTrench': 'Ten rów to prostokąt. Pole jest na górze, bok na dole.',
  'l4.ctx.shareGrid': 'Ta krata to prostokąt. Pole jest na górze, bok na dole.',
  'l4.ctx.gatePair': 'Napęd staje, gdy dwa odczyty tarczy mnożą się do zera.',
  'l4.ctx.gateValve': 'Zawór zamyka się, gdy dwa odczyty dźwigni mnożą się do zera.',
  'l4.ctx.gateLatch': 'Zapadka opada, gdy dwa odczyty zaczepu mnożą się do zera.',
  'l4.ctx.gateRelay': 'Przekaźnik otwiera się, gdy dwa odczyty cewki mnożą się do zera.',
  'l4.ctx.throwFlare': 'Kadet wystrzeliwuje racę. Ta reguła podaje jej wysokość co sekundę.',
  'l4.ctx.throwPod': 'Dźwig podnosi kapsułę. Ta reguła podaje jej wysokość co sekundę.',
  'l4.ctx.throwDrone': 'Dron wznosi się i opada. Ta reguła podaje jego wysokość co sekundę.',
  'l4.ctx.throwBuoy': 'Kadet rzuca boję. Ta reguła podaje jej wysokość co sekundę.',
  'l4.ctx.landFlare': 'Kadet wystrzeliwuje racę. Spada, gdy jej wysokość dochodzi do zera.',
  'l4.ctx.landPod': 'Dźwig zwalnia kapsułę. Spada, gdy jej wysokość dochodzi do zera.',
  'l4.ctx.landDrone': 'Dron wznosi się i opada. Spada, gdy jego wysokość dochodzi do zera.',
  'l4.ctx.landBuoy': 'Kadet rzuca boję. Spada, gdy jej wysokość dochodzi do zera.',
  'l4.ctx.fencePen': 'Zagroda ma płot o stałej długości. Ta reguła podaje jej pole.',
  'l4.ctx.fenceYard': 'Dziedziniec ma płot o stałej długości. Ta reguła podaje jego pole.',
  'l4.ctx.fenceRun': 'Wybieg ma płot o stałej długości. Ta reguła podaje jego pole.',
  'l4.ctx.fenceLot': 'Parcela ma płot o stałej długości. Ta reguła podaje jej pole.',
  'l4.ctx.priceTicket': 'Stoisko ustala cenę biletu. Ta reguła podaje utarg.',
  'l4.ctx.pricePart': 'Warsztat ustala cenę części. Ta reguła podaje utarg.',
  'l4.ctx.priceRation': 'Sklep ustala cenę racji. Ta reguła podaje utarg.',
  'l4.ctx.pricePass': 'Brama ustala cenę przepustki. Ta reguła podaje utarg.',
  'l4.ctx.archSpan': 'Przęsło wznosi się i opada. Ta reguła podaje jego wysokość.',
  'l4.ctx.archCable': 'Lina opada i wznosi się. Ta reguła podaje jej wysokość.',
  'l4.ctx.archRib': 'Żebro wznosi się i opada. Ta reguła podaje jego wysokość.',
  'l4.ctx.archDome': 'Kopuła wznosi się i opada. Ta reguła podaje jej wysokość.',
  'l4.ctx.disputeWatch': 'Dwaj kadeci z tej samej wachty nie zgadzają się co do tego.',
  'l4.ctx.disputeBench': 'Dwaj kadeci przy tym samym stole nie zgadzają się co do tego.',
  'l4.ctx.disputeCheck': 'Dwaj kadeci sprawdzający się nawzajem nie zgadzają się co do tego.',
  'l4.ctx.disputeBay': 'Dwaj kadeci w tej samej zatoce nie zgadzają się co do tego.',
  'l4.ctx.disputeSurvey': 'Dwaj kadeci z tego samego pomiaru nie zgadzają się co do tego.',
  'l4.ctx.disputeConsole': 'Dwaj kadeci przy tej samej konsoli nie zgadzają się co do tego.',

  // ---------------------------------------------------------------- uzasadnienia
  'l4.why.largestSquareInside': '{sq} to największy kwadrat, który dzieli liczbę pod kreską.',
  'l4.why.squareComesOut': 'Kwadrat spod kreski wychodzi jako swój pierwiastek, więc wychodzi {m}.',
  'l4.why.frontTimesWhatCameOut': 'Pomnóż {c} z przodu przez {m}, które wyszło.',
  'l4.why.shareTheFront': 'Teraz podziel liczbę z przodu przez {p}.',
  'l4.why.addUnderTheBarFirst': 'Najpierw dodaj pod kreską. Jedna kreska obejmuje całą sumę.',
  'l4.why.sameUnderTheBar': 'Oba pierwiastki mają pod kreską {k}, więc liczą się razem.',
  'l4.why.countTheRoots': 'Policz pierwiastki. Liczba pod kreską się nie zmienia.',
  'l4.why.takeEachSquareOut': 'Najpierw wyciągnij kwadrat z każdego pierwiastka.',
  'l4.why.timesTheSameRoot': 'Pomnóż górę i dół przez pierwiastek z {k}.',
  'l4.why.shareTheRootOver': 'Pierwiastek z zewnątrz sięga każdego wyrazu w nawiasie.',
  'l4.why.rootTimesItself': 'Pierwiastek razy sam siebie daje {k}.',
  'l4.why.pairMultipliesAndAdds': 'Jedna para mnoży się do {c} i dodaje do {b}.',
  'l4.why.eachNumberItsBracket': 'Każda liczba z pary bierze swój nawias.',
  'l4.why.constantIsASquare': 'Ostatni wyraz to {p} razy {p}.',
  'l4.why.sameBracketTwice': 'Nawias użyty dwa razy to ten nawias do kwadratu.',
  'l4.why.commonFactorFirst': 'Najpierw wyłącz {g} z każdego wyrazu.',
  'l4.why.firstTimesLast': '{a} razy {c} to liczba, do której para ma się mnożyć.',
  'l4.why.shareTheFrontNumber': 'Oba nawiasy dzielą się liczbą {a} z przodu.',
  'l4.why.frontIsASquare': 'Pierwszy wyraz to kwadrat z {p} liter.',
  'l4.why.bothPartsAreSquares': 'Obie części to kwadraty, a {c} razy {c} daje ostatnią.',
  'l4.why.onePlusOneMinus': 'Jeden nawias dodaje, a drugi odejmuje.',
  'l4.why.aCubeIsNotASquare': 'Odjęty sześcian to nie odjęty kwadrat.',
  'l4.why.plusDoesNotComeApart': 'Dwa kwadraty z plusem między nimi zostają razem.',
  'l4.why.zeroMeansTheRuleReadsZero': 'Miejsce zerowe reguły to wejście, w którym reguła ma zero.',
  'l4.why.noSquareIsBelowZero': 'Żaden kwadrat nie leży poniżej zera, więc żadne wejście nie pasuje.',
  'l4.why.oneBarOverEachTerm': 'Jedna kreska nad sumą to kreska nad każdym wyrazem.',
  'l4.why.multiplyBackToCheck': 'Pomnóż z powrotem. Dół razy odpowiedź daje górę.',
  'l4.why.factorTheTopFirst': 'Najpierw zapisz górę jako iloczyn.',
  'l4.why.whatIsLeftOver': 'Iloczynowi brakuje tyle, więc tyle zostaje.',
  'l4.why.thatIsWhatTheBottomNeeds': 'Dół potrzebuje dokładnie tego, żeby dać górę.',
  'l4.why.oneBracketIsZero': 'Iloczyn ma zero, gdy jeden nawias ma zero.',
  'l4.why.sameStatementOpenedOut': 'Po rozwinięciu ten sam zapis wygląda tak.',
  'l4.why.andTheOtherBracket': 'Drugi nawias daje drugi odczyt.',
  'l4.why.everythingOnOneSide': 'Przenieś wszystko na jedną stronę. Druga strona ma teraz zero.',
  'l4.why.nowTheBracketsCanBeZero': 'Teraz działa reguła dwóch nawiasów, bo druga strona ma zero.',
  'l4.why.onlyOneWidthCanBeReal': 'Szerokość poniżej zera nie jest szerokością, więc jeden odczyt odpada.',
  'l4.why.onlyOneLengthCanBeReal': 'Długość poniżej zera nie jest długością, więc jeden odczyt odpada.',
  'l4.why.rootBothSides': 'Spierwiastkuj obie strony. Kwadrat ma dwa pierwiastki.',
  'l4.why.twoRootsOneEach': 'Jeden pierwiastek to {s}. Drugi to minus {s}.',
  'l4.why.undoTheShiftLast': 'Przenieś {h} na koniec, już po pierwiastku.',
  'l4.why.freeTheSquare': 'Najpierw zostaw sam nawias do kwadratu.',
  'l4.why.halfTheMiddleSquared': 'Połowa {b}, podniesiona do kwadratu, uzupełnia kwadrat.',
  'l4.why.addItAndTakeItBack': 'Dodaj {sq}, żeby zbudować kwadrat. Potem odejmij {sq} z powrotem.',
  'l4.why.divideTheFrontOutFirst': 'Najpierw wyłącz {a} z dwóch pierwszych wyrazów.',
  'l4.why.putTheThreeNumbersIn': 'Wstaw trzy liczby do wzoru.',
  'l4.why.workOutUnderTheRoot': 'Część pod pierwiastkiem wychodzi {disc}.',
  'l4.why.thenTakeTheRoot': 'Pierwiastek z tej części to {root}.',
  'l4.why.noRootBelowZero': 'Żadna liczba rzeczywista podniesiona do kwadratu nie da liczby poniżej zera.',
  'l4.why.onlyTheTimeAfterLaunch': 'Realny może być tylko czas po starcie.',
  'l4.why.turnIsMinusBOverTwoA': 'Wierzchołek leży w minus liczbie środkowej przez dwie liczby pierwsze z przodu.',
  'l4.why.readTheRuleAtTheTurn': 'Odczytaj regułę w {h}, żeby poznać tamtejszą wartość.',
  'l4.why.theLineRunsThroughTheTurn': 'Prosta biegnie pionowo przez wierzchołek.',
  'l4.why.putZeroIn': 'Wstaw zero w miejsce litery.',
  'l4.why.onlyTheLastTermSurvives': 'Każdy wyraz z literą znika, więc zostaje ostatni.',
  'l4.why.opensUpSoNothingLower': 'Krzywa otwiera się do góry, więc nic nie leży niżej niż wierzchołek.',
  'l4.why.opensDownSoNothingHigher': 'Krzywa otwiera się w dół, więc nic nie leży wyżej niż wierzchołek.',
  'l4.why.secondDifferencesAreEqual': 'Odstępy między odstępami są równe, więc pasuje reguła kwadratowa.',
  'l4.why.readTheRuleAt': 'Odczytaj tę regułę w {at}.',
  'l4.why.vertexFormShape': 'Ta postać pokazuje wierzchołek.',
  'l4.why.putTheTurnIn': 'Wstaw {h} i {k} do tej postaci.',
  'l4.why.squareTheBracketFirst': 'Najpierw podnieś nawias do kwadratu.',
  'l4.why.shareThenJoin': 'Rozdziel liczbę do środka. Potem połącz wyrazy podobne.',
  'l4.why.aZeroMakesABracket': 'Zero w {p} daje jeden nawias.',
  'l4.why.bothZerosBothBrackets': 'Oba zera dają oba nawiasy.',
};
